import React, { useCallback } from 'react';
import { Container, Card, CardBody, Button, Spinner } from 'reactstrap';

import { Link, useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import CompaniesList from './components/expertise-list';
import ExpertiseList from './components/expertise-list';

const AdvisoryExpertises = (props) => {
  const history = useHistory();
  const [advisoryExpertises, , advisoryExpertisesLoading] = useGet(
    '/advisory-expertises?filter[order]=createdAt DESC',
    true
  );
  const handleEditAdvisoryExpertises = useCallback(
    (obj) => {
      history.push(`/system/advisors-expertise-details/${obj.id}`);
    },
    [history]
  );
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Advisory Expertise</h4>
            <Link to='/system/add-new-advisory-expertise'>
              <Button
                color='primary'
                outline
                type='button'
                size='sm'
                className='waves-effect waves-light'
              >
                Add New Advisory Expertise{' '}
                <i className='mdi mdi-plus align-middle ml-2'></i>
              </Button>
            </Link>
          </div>
          <Card>
            <CardBody>
              {advisoryExpertisesLoading ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <ExpertiseList
                  expertises={advisoryExpertises}
                  editExpertise={handleEditAdvisoryExpertises}
                ></ExpertiseList>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default AdvisoryExpertises;
